import React from "react";
import TextCitation from "./citationTypes/TextCitation";
import ChowsAndBlogsCitations from "./citationTypes/ChowsAndBlogsCitations";
import PodcastCitations from "./citationTypes/PodcastCitations";
import ExclusiveContentCitations from "./citationTypes/ExclusiveContentCitations";
import BookCitations from "./citationTypes/BookCitations";

interface CitationRendererProps {
  citation: string | any; // can be string or object
  isLoading?: boolean;
  onCitationClick?: (citation: any) => void;
}

const CitationHandler: React.FC<CitationRendererProps> = ({ citation, isLoading, onCitationClick }) => {
  if (typeof citation === "string") {
    return <TextCitation isLoading={isLoading} citation={citation} onCitationClick={onCitationClick} />;
  }

  const { media_type, link } = citation;

  if (media_type === "podcast" || media_type === "sps_podcast" || media_type === "fsl_podcast") {
    const iconTitle = media_type === "fsl_podcast" ? "Full-Stack Leadership Podcast Summary" : "Software People Stories Podcast Summary";
    return <PodcastCitations citation={citation} onCitationClick={onCitationClick} iconTitle={iconTitle} />;
  }

  if ((media_type === "blog" || media_type === undefined) && link !== "") {
    return <ChowsAndBlogsCitations citation={citation} />;
  }

  if (media_type === "books") {
    return <BookCitations citation={citation} onCitationClick={onCitationClick} />;
  }
  return <ExclusiveContentCitations citation={citation} onCitationClick={onCitationClick} />;
};

export default CitationHandler;
